"use client";
import {NeoButton, NeoDatePicker, NeoSelect} from "@/components/forms";
//import {UsersFilterConfig} from "@/data/users/filter.config";
import {useNeoContext} from "@/context/neo/neo.context";
import Select from "react-select";
/**
 * TODO: @selva,@surya,@arun
 * Create a Validation Schema if you have a form & inject them
 */
import {Button, Chip, Image, SelectItem, Switch} from "@nextui-org/react";
import {ChangeEvent, useEffect, useMemo, useState} from "react";
import {Controller, useForm} from "react-hook-form";
export const ReportFilter: React.FC<ReportsFilterProps> = ({
  onSubmit,
  activeFilters,
  oldFilter,
  innerFilters
}) => {
  const reportFilterConfig = {
    mainFilter: [
      {
        label: "Today",
        value: "1"
      },
      {
        label: "Yesterday",
        value: "2"
      },
      {
        label: "Current Week",
        value: "3"
      },
      {
        label: "Last Week",
        value: "4"
      },
      {
        label: "Current Month",
        value: "5"
      },
      {
        label: "Last Month",
        value: "6"
      },
      {
        label: "Range",
        value: "7"
      }
    ],
    source: [
      {
        label: "All",
        value: "0"
      },
      {
        label: "Biometric",
        value: "1"
      },
      {
        label: "UHF",
        value: "2"
      }
    ]
  };

  const {control, register, handleSubmit, setValue} = useForm();
  const {vehicles, uhfHardwareGroups} = useNeoContext();
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    from: null,
    to: null
  });
  //const [selectedFilterType, setSelectedFilterType] = useState("1");
  // const [selectedFilterVehicleOne, setSelectedFilterVehicleOne] = useState();

  const [showDateRange, setShowDateRange] = useState(false);
  //advanced filters start
  const [selectedFilters, setSelectedFilters] = useState<{
    [key: string]: number[];
  }>({});

  // Step 1: Initialize with default values
  useEffect(() => {
    // console.log("innerFilters", oldFilter);
    if (innerFilters) {
      const initialFilters: {[key: string]: number[]} = {};
      innerFilters.forEach((filter: any) => {
        initialFilters[filter.uid] =
          oldFilter.filters[filter.uid] || filter.defaultValue || [];
      });
      //console.log({...oldFilter.filters, ...initialFilters});
      setSelectedFilters({...oldFilter.filters, ...initialFilters});
    } else {
      // console.log({...oldFilter.filters});
      setSelectedFilters({...oldFilter.filters});
    }
  }, [innerFilters]);
  const resetFiltervalue = (filter: number) => {
    if (filter === 1) {
      // filter Type
      if (oldFilter.filterType) {
        if (oldFilter.filterType == "7") {
          //range
          setShowDateRange(true);
          if (oldFilter.from && oldFilter.to) {
            const fromDate = new Date(oldFilter.from);
            const toDate = new Date(oldFilter.to);
            const selectedDateRange = {
              from: fromDate,
              to: toDate
            };
            setSelectedDateRange(selectedDateRange);
          }
        } else {
          handleFromToFilterData(oldFilter.filterType);
        }
        return oldFilter.filterType;
      } else {
        handleFromToFilterData("1");
        return "1";
      }
    }
    if (filter === 2) {
      // Vehicle Single Filter
      if (oldFilter.trackerId) {
        if (Array.isArray(oldFilter.trackerId)) {
          return oldFilter.trackerId[0];
        } else {
          return oldFilter.trackerId;
        }
      } else {
        return vehicles.length > 0 ? vehicles[0]?.trackerId : 0;
      }
    }

    if (filter === 3) {
      if (oldFilter.trackerId && Array.isArray(oldFilter.trackerId)) {
        return oldFilter.trackerId;
      } else {
        return vehicles.map(v => v.trackerId);
      }
    }

    if (filter === 4) {
      const fromDate = new Date(oldFilter.from);
      const toDate = new Date(oldFilter.to);
      const selectedDateRange = {
        from: fromDate,
        to: toDate
      };
      setSelectedDateRange(selectedDateRange);
      return fromDate;
    }
    if (filter === 6) {
      // UHF Group Filter
      if (oldFilter?.groupId && oldFilter?.filters?.groupId.length > 0) {
        return oldFilter?.filters?.groupId;
      } else {
        let uhfHardwareGroupIds: any = [];
        if (uhfHardwareGroups && uhfHardwareGroups.length > 0) {
          uhfHardwareGroupIds = uhfHardwareGroups.map((group: any) =>
            group.id.toString()
          );
        }
        return uhfHardwareGroupIds;
      }
    }
  };

  const handleFilterTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const filterType = e.target.value;
    setShowDateRange(false);
    handleFromToFilterData(filterType);
    //setSelectedFilterType(filterType);
    setValue("filterType", filterType);
  };

  const handleFromToFilterData = (filterType: any) => {
    const currentDate = new Date();
    if (filterType === "1") {
      //Today
      const fromDate = new Date(currentDate);
      const toDate = new Date(currentDate);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: fromDate,
        to: toDate
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "2") {
      //Yesterday
      const fromDate = new Date(currentDate);
      fromDate.setDate(currentDate.getDate() - 1);
      const toDate = new Date(currentDate);
      toDate.setDate(currentDate.getDate() - 1);

      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);

      const selectedDateRange = {
        from: fromDate,
        to: toDate
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "3" || filterType === "4") {
      //current and last week
      const dayOfWeek = currentDate.getDay(); // 0 (Sun) - 6 (Sat)
      const diffToMonday = (dayOfWeek + 6) % 7; // Days since last Monday
      // Current week
      const currentWeekFrom = new Date(currentDate);
      currentWeekFrom.setDate(currentDate.getDate() - diffToMonday);
      currentWeekFrom.setHours(0, 0, 0, 0);

      const currentWeekTo = new Date(currentWeekFrom);
      currentWeekTo.setDate(currentWeekFrom.getDate() + 6);
      currentWeekTo.setHours(23, 59, 59, 999);

      //current week shouldnot end last day of the week
      const currentWeekTodayTo = new Date(currentDate);
      currentWeekTodayTo.setHours(23, 59, 59, 999);

      // Last week
      const lastWeekFrom = new Date(currentWeekFrom);
      lastWeekFrom.setDate(currentWeekFrom.getDate() - 7);

      const lastWeekTo = new Date(currentWeekTo);
      lastWeekTo.setDate(currentWeekTo.getDate() - 7);

      if (filterType === "3") {
        //current week
        const selectedDateRange = {
          from: currentWeekFrom,
          to: currentWeekTodayTo
        };
        setSelectedDateRange(selectedDateRange);
      } else if (filterType === "4") {
        //lastweek
        const selectedDateRange = {
          from: lastWeekFrom,
          to: lastWeekTo
        };
        setSelectedDateRange(selectedDateRange);
      }
    } else if (filterType === "5") {
      //current month
      const currentMonthFrom = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const currentMonthTo = new Date(currentDate);
      currentMonthTo.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: currentMonthFrom,
        to: currentMonthTo
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "6") {
      //last month
      const lastMonthFrom = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const lastMonthTo = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      lastMonthTo.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: lastMonthFrom,
        to: lastMonthTo
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "7") {
      //selected range
      setShowDateRange(true);
    }
  };
  // Memoize default values for the filters to avoid recomputation on each render
  const defaultFilterType = useMemo(() => resetFiltervalue(1), []);
  const defaultVehicleSingle = useMemo(() => resetFiltervalue(2), []);
  const defaultVehicleMultiple = useMemo(() => resetFiltervalue(3), []);
  const defaultSingleDate = useMemo(() => resetFiltervalue(4), []);

  const defaultUHFGroup = useMemo(() => resetFiltervalue(6), []);
  // const defaultSource = useMemo(() => resetFiltervalue(5), []);
  // const defaultUserType = useMemo(() => resetFiltervalue(7), []);

  const onDateChange = (event: any) => {
    setSelectedDateRange(event);
  };
  const innerFilterdefaultValue = (selctedFilter: any) => {
    // console.log(selctedFilter);
    if (selctedFilter.uid === "userType") {
      if (oldFilter.filters.userType) {
        return oldFilter.filters.userType;
      } else {
        return selctedFilter.defaultValue; // Default to "Student"
      }
    }
    if (selctedFilter.uid === "source") {
      if (oldFilter.filters.source) {
        return oldFilter.filters.source;
      } else {
        return selctedFilter.defaultValue; // Default to "All"
      }
    }
  };
  const onSingleDateChange = (event: any) => {
    event.setHours(0, 0, 0, 0);
    event.setHours(23, 59, 59, 999);
    event.from = event.getTime();
    event.to = event.getTime();
    setSelectedDateRange(event);
  };
  const onSubmitEvent = (event: any) => {
    //handle Filter functionality
    event.filters = selectedFilters;
    //console.log(event);

    //console.log("onSubmitEvent", selectedFilters);
    if (selectedDateRange.from && selectedDateRange.to) {
      const fromDate = new Date(selectedDateRange.from);
      const toDate = new Date(selectedDateRange.to);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      event.from = fromDate.getTime();
      event.to = toDate.getTime();
    }

    if ("trackerId" in event) {
      if (event.trackerId) {
        event.filters.trackers = Array.isArray(event.trackerId)
          ? [...event.trackerId]
          : [event.trackerId];
        onSubmit(event);
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(event, "from") &&
        Object.prototype.hasOwnProperty.call(event, "to")
      ) {
        onSubmit(event);
      }
    }

    /*if (Object.prototype.hasOwnProperty.call(event, "trackerId")) {
      if (event.trackerId) {
        onSubmit(event);
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(event, "from") &&
        Object.prototype.hasOwnProperty.call(event, "to")
      ) {
        onSubmit(event);
      }
    }*/
  };

  // Step 2: Toggle logic for multiSelect
  const toggleMultiSelect = (uid: string, id: number) => {
    setSelectedFilters(prev => {
      const current = prev[uid] || [];
      const updated = current.includes(id)
        ? current.filter(i => i !== id)
        : [...current, id];
      return {...prev, [uid]: updated};
    });
  };

  // Step 3: Toggle logic for switch
  const toggleSwitch = (uid: string, id: number, checked: boolean) => {
    setSelectedFilters(prev => ({
      ...prev,
      [uid]: checked ? [id] : []
    }));
  };
  const handleSelectfilerChange = (e: any) => {
    const {value, name} = e.target;
    // console.log("handleSelectfilerChange", selectedFilters);

    setSelectedFilters(prev => ({
      ...prev,
      [name]: value ? value : 0
    }));
  };
  const handleSelectFilterUhfGroupChange = (e: any) => {
    const {value, name} = e.target;
    const groupIds = value.split(",");
    setSelectedFilters(prev => ({
      ...prev,
      [name]: groupIds.length > 0 ? groupIds : []
    }));
  };
  const vehicleOptions = vehicles.map(v => ({
    label: v.trackerName,
    value: v.trackerId
  }));
  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          onSubmitEvent(event);
        })}
      >
        <div className="flex w-[350px] flex-col gap-5 p-5 ">
          {activeFilters.map(
            (filter: any, index: number) =>
              (filter === "singleDate" && (
                <NeoDatePicker
                  label="Date"
                  handleDateChange={onSingleDateChange}
                  value={defaultSingleDate}
                />
              )) ||
              (filter === "date" && (
                <>
                  <NeoSelect
                    {...register("filterType")}
                    label="Filter Type"
                    defaultSelectedKeys={[defaultFilterType]}
                    onChange={handleFilterTypeChange}
                  >
                    {reportFilterConfig?.mainFilter?.map(item => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </NeoSelect>
                  {showDateRange && (
                    <NeoDatePicker
                      type={"range"}
                      label="Date Range"
                      handleDateChange={onDateChange}
                      rangedefaultValue={selectedDateRange}
                    />
                  )}
                </>
              )) ||
              (filter === "vehicle" && (
                // <Controller
                //   control={control}
                //   name="trackerId"
                //   defaultValue={defaultVehicleMultiple}
                //   render={({field}) => (
                //     <NeoSelect
                //       label="Vehicle"
                //       selectionMode="multiple"
                //       selectedKeys={new Set(field.value || [])}
                //       onSelectionChange={keys =>
                //         field.onChange(Array.from(keys))
                //       }
                //     >
                //       {vehicles.map(item => (
                //         <SelectItem key={item.trackerId} value={item.trackerId}>
                //           {item.trackerName}
                //         </SelectItem>
                //       ))}
                //     </NeoSelect>
                //   )}
                // />
                <Controller
                  control={control}
                  name="trackerId"
                  defaultValue={defaultVehicleMultiple} // must be an array of trackerIds
                  render={({field}) => {
                    const selectedOptions = vehicleOptions.filter(opt =>
                      field.value?.includes(opt.value)
                    );

                    const handleChange = (selected: any) => {
                      field.onChange(selected.map((item: any) => item.value));
                    };

                    const handleSelectAll = () => {
                      field.onChange(vehicleOptions.map(opt => opt.value));
                    };

                    const handleDeselectAll = () => {
                      field.onChange([]);
                    };

                    return (
                      <div className="flex flex-col gap-2 rounded-2xl border border-gray-300 p-4">
                        <div className="mb-1 flex justify-between">
                          Vehicle
                          <div className="flex gap-2">
                            <Button
                              size="sm"
                              className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                              onPress={handleSelectAll}
                            >
                              Select All
                            </Button>
                            <Button
                              size="sm"
                              onPress={handleDeselectAll}
                              className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                            >
                              Deselect All
                            </Button>
                          </div>
                        </div>
                        <Select
                          isMulti
                          options={vehicleOptions}
                          value={selectedOptions}
                          onChange={handleChange}
                          placeholder="Select vehicle(s)..."
                          classNamePrefix="react-select"
                          closeMenuOnSelect={false}
                          isClearable={false}
                          //backspaceRemovesValue={true} // its used to remove the selected value on backspace
                          //  closeMenuOnScroll={false}
                          styles={{
                            control: (base: any) => ({
                              ...base,
                              minHeight: "40px",
                              borderColor: "#d4d4d8",
                              boxShadow: "none",
                              "&:hover": {
                                borderColor: "#d4d4d8"
                              }
                            }),
                            valueContainer: (base: any) => ({
                              ...base,
                              maxHeight: "100px",
                              overflowY: "auto",
                              flexWrap: "wrap"
                            }),
                            multiValue: (base: any) => ({
                              ...base,
                              backgroundColor: "white",
                              border: "1px solid #d4d4d8",
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                            }),
                            multiValueLabel: (base: any) => ({
                              ...base,
                              color: "#131313"
                            }),
                            multiValueRemove: (base: any) => ({
                              ...base,
                              color: "#131313",
                              float: "right",
                              ":hover": {
                                backgroundColor: "#d4d4d8",
                                color: "#131313"
                              }
                            }),
                            option: (base: any, state: any) => ({
                              ...base,
                              backgroundColor: state.isFocused
                                ? "#d4d4d8"
                                : "white",
                              color: "#000",
                              cursor: "pointer"
                            })
                          }}
                        />
                      </div>
                    );
                  }}
                />
              )) ||
              (filter === "vehicleSingle" && (
                // <NeoSelect
                //   {...register("trackerId")}
                //   label="Vehicle"
                //   defaultSelectedKeys={[defaultVehicleSingle]}
                // >
                //   {vehicles.map(item => (
                //     <SelectItem key={item.trackerId} value={item.trackerId}>
                //       {item.trackerName}
                //     </SelectItem>
                //   ))}
                // </NeoSelect>
                <div className="flex flex-col gap-1">
                  <label
                    // style={style.label}
                    id="aria-label"
                    htmlFor="aria-example-input"
                  >
                    Vehicle
                  </label>
                  <Select
                    name="trackerId"
                    options={vehicleOptions}
                    defaultValue={vehicleOptions.find(
                      opt => opt.value === defaultVehicleSingle
                    )}
                    onChange={selectedOption => {
                      setValue("trackerId", selectedOption?.value); // react-hook-form setter
                    }}
                    placeholder="Select Vehicle"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "40px",
                        borderWidth: "2px",
                        borderColor: "#d4d4d8",
                        borderRadius: "12px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        boxShadow: "none",
                        fontSize: "14px",
                        color: "#111827",
                        backgroundColor: "white",
                        "&:hover": {
                          borderColor: "#d4d4d8"
                        }
                      }),
                      placeholder: base => ({
                        ...base,
                        color: "#6b7280",
                        fontSize: "14px"
                      }),
                      indicatorSeparator: () => ({
                        display: "none"
                      }),
                      dropdownIndicator: base => ({
                        ...base,
                        color: "#6b7280",
                        paddingRight: "8px"
                      }),
                      // singleValue: base => ({
                      //   ...base,
                      //   color: "#111827"
                      // }),
                      menu: base => ({
                        ...base,
                        borderRadius: "10px",
                        zIndex: 50
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? "#e5e7eb" : "white",
                        color: "#111827",
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        margin: "2px 4px"
                      })
                    }}
                  />
                </div>
              )) ||
              (filter === "uhfGroup" && (
                <NeoSelect
                  {...register("groupId")}
                  label="UHF Group"
                  defaultSelectedKeys={defaultUHFGroup}
                  selectionMode="multiple"
                  onChange={handleSelectFilterUhfGroupChange}
                >
                  {uhfHardwareGroups.map(item => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.name}
                    </SelectItem>
                  ))}
                </NeoSelect>
              ))
          )}
          {innerFilters?.map((filter: any) =>
            filter.type === "selectBoxSingle" ? (
              <>
                <NeoSelect
                  {...register(filter.uid)}
                  label={filter.label}
                  defaultSelectedKeys={[innerFilterdefaultValue(filter) || "0"]}
                  onChange={handleSelectfilerChange}
                >
                  {filter.options.map((item: any) => (
                    <SelectItem key={item.id} value={item.name}>
                      {item.name}
                    </SelectItem>
                  ))}
                </NeoSelect>
              </>
            ) : (
              <div key={filter.uid} className="mb-4">
                <h3 className="mb-2 text-sm font-semibold">{filter.label}</h3>
                <div className="flex flex-wrap gap-2">
                  {filter.options.map((opt: any) => {
                    const isSelected = selectedFilters[filter.uid]?.includes(
                      opt.id
                    );
                    return (
                      <div key={opt.id}>
                        {filter.type === "multiSelect" && (
                          <Chip
                            color={isSelected ? "primary" : "default"}
                            onClick={() =>
                              toggleMultiSelect(filter.uid, opt.id)
                            }
                            className="cursor-pointer"
                          >
                            {opt.name}
                          </Chip>
                        )}
                        {filter.type === "switch" && (
                          <Switch
                            isSelected={isSelected}
                            onChange={e =>
                              toggleSwitch(filter.uid, opt.id, e.target.checked)
                            }
                            size="md"
                          >
                            {opt.name}
                          </Switch>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )
          )}
          <div className="w-100 flex justify-end">
            <NeoButton
              type="submit"
              color="yellow"
              className="gap-[5px] text-lg"
              startContent={
                <Image
                  className="h-5 w-5"
                  src="/icons/filter.svg"
                  alt="filter"
                />
              }
            >
              Filter
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
